import React from "react";
import { Modal } from "react-bootstrap";
import { getFormattedDate } from "../../utils/helper";

const ProjectDetailsModel = ({ open, handleClose, data }) => {
  if (!data) return null;

  // Helper to render aligned rows
  const DetailRow = ({ label, value, isBold = false }) => (
    <div className="row mb-2 border-bottom pb-2">
      <div className="col-5 col-md-4">
        <span className="text-secondary fw-bold text-uppercase point-14">{label}:</span>
      </div>
      <div className="col-7 col-md-8">
        <span className={`${isBold ? "fw-bold" : "fw-normal"} text-dark point-16`}>
          {value || "N/A"}
        </span>
      </div>
    </div>
  );

  return (
    <Modal show={open} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton className="bg-primary text-white border-0">
        <Modal.Title className="fw-bold">Project Overview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="container-fluid">
          {/* Project Title Header */}
          <div className="mb-4">
            <h3 className="text-primary fw-boldest mb-0">{data.project_title}</h3>
            <small className="text-muted text-uppercase">Project ID: {data.project_id}</small>
          </div>

          {/* Aligned Details Column */}
          <div className="bg-white p-3 rounded shadow-sm border">
            <DetailRow label="DBE Goal" value={`${data.dbe_goal}%`} isBold={true} />
            <DetailRow label="City" value={data.city} />
            <DetailRow label="Date Posted" value={getFormattedDate(data.date_entered)} />
            <DetailRow label="Date Due" value={getFormattedDate(data.estimated_end_date)} />
            <DetailRow label="Work Types" value={data.worktypeLabels} />
            
            {/* Description is usually longer, so we give it its own block but keep the label aligned */}
            <div className="row mt-3">
              <div className="col-12">
                <p className="text-secondary fw-bold text-uppercase point-14 mb-2">Description:</p>
                <div className="p-3 bg-light rounded border text-muted" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {data.description || "No description available for this project."}
                </div>
              </div>
            </div>
          </div>

          {/* Scope of Work Button aligned to the right or center */}
          <div className="mt-4 d-flex justify-content-between">
            <button className="btn btn-outline-secondary px-4" onClick={handleClose}>
              Close
            </button>
            {data.download_url && (
              <a
                href={data.download_url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary text-primary fw-bold px-4 shadow-sm"
              >
                <i className="bi bi-download me-2"></i>
                Download Scope of Work
              </a>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProjectDetailsModel;